// extracted by mini-css-extract-plugin
module.exports = {"container":"MembersStrip_container__3ndk_","stripWrapper":"MembersStrip_stripWrapper__3QiwO","strip":"MembersStrip_strip__1lB4D","stripItem":"MembersStrip_stripItem__3lFLO"};